import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from 'admin/components/atoms/Buttons';
import TextBox from 'admin/components/atoms/TextBox';
import TextArea from 'admin/components/atoms/TextArea';
import CheckBox from 'admin/components/atoms/CheckBox';
import Radio from 'admin/components/atoms/Radio';
import Labeled from 'admin/components/atoms/Labeled';
import LabeledCheckBox from 'admin/components/molecules/LabeledCheckBox';
import { TableHeader, TableRow, TableCell } from 'admin/components/atoms/Tables';
import { createSchemaFromObject } from './schema';

const FormWrapper = styled.div`
  margin-top:    20px;
  margin-left:   30px;
  margin-bottom: 20px;
  margin-right:  30px;
`;

const OptionsTableRow = ({
  option, index, deleteOptions, editOptions, formType, defaultValue, updateSchema, setDefaultValues,
}) => {
  const handleSetItem = (key, item) => {
    editOptions({ label: item, value: item }, index);
  };

  const handleDelete = (e, i) => {
    e.preventDefault();
    deleteOptions(i);
  };

  return (
    <TableRow>
      <TableCell size="1" align="center">
        {formType === 'radio'
         ? (
           <Radio
             checked={!(defaultValue == null) ? option.value === defaultValue : false}
             setChecked={() => updateSchema('default', option.value)}
           />
         )
         : (
           <CheckBox
             checked={
               Array.isArray(defaultValue)
                 ? defaultValue.find(v => v === option.value) === option.value
                 : false
             }
             setChecked={(checked) => {
               setDefaultValues((oldArr) => {
                 const arr = checked
                       ? [...oldArr, option.value]
                       : oldArr.filter(opt => opt !== option.value);
                 updateSchema('default', arr);
                 return arr;
               });
             }}
           />
         )}
      </TableCell>
      <TableCell size="4" align="center">
        <TextBox
          style={{ width: '100%' }}
          value={option.label}
          onBlur={e => handleSetItem('label', e.target.value)}
          required
        />
      </TableCell>
      <TableCell size="2" align="center">
        {index !== 0
         ? (
           <Button style={{ backgroundColor: 'red' }} onClick={e => handleDelete(e, index)} >
             削除
           </Button>
         )
         : null}
      </TableCell>
    </TableRow>
  );
};

const SetOptionsForm = ({
  addOptions, editOptions, deleteOptions, schema, formType, defaultValue, updateSchema, setSchema,
}) => {
  const [defaultValues, setDefaultValues] = useState([]);
  const [isRequired, setIsRequired] = useState(null);

  const rows = schema.options.map((option, index) => (
    <OptionsTableRow
      key={`options-${index + 1}`}
      option={option}
      index={index}
      deleteOptions={deleteOptions}
      editOptions={editOptions}
      formType={formType}
      defaultValue={defaultValue}
      updateSchema={updateSchema}
      setDefaultValues={setDefaultValues}
    />
  ));

  const updateSchemas = (values) => {
    const newSchema = createSchemaFromObject(schema);
    const keys = Object.keys(values);
    keys.forEach(k => newSchema.setValueFromKey(k, values[k]));
    setSchema(newSchema);
  };

  const onCheckRequired = (op) => {
    setIsRequired(op);
    if (op === false) {
      updateSchemas({
        required: false,
        required_reason: '',
      });
    } else {
      updateSchemas({
        required: true,
      });
    }
  };

  const handleAdd = (e) => {
    e.preventDefault();
    addOptions();
  };

  const handleClear = (e) => {
    e.preventDefault();
    updateSchema('default', null);
  };

  return (
    <FormWrapper>
      <TableHeader>
        <TableCell size="1" align="center">初期設定値</TableCell>
        <TableCell size="4" align="center">選択肢</TableCell>
        <TableCell size="2" align="center" />
      </TableHeader>
      {rows}
      <Button onClick={e => handleAdd(e)} >追加</Button>
      <Button onClick={e => handleClear(e)} >初期設定値クリア</Button>
      <LabeledCheckBox
        labelText="必須項目"
        checked={isRequired}
        setChecked={onCheckRequired}
      />
      {isRequired
       ? (
         <Labeled labelText="必須事由" required >
           <TextArea
             value={schema.required_reason}
             onChange={e => updateSchema('required_reason', e.target.value)}
             required
           />
         </Labeled>
       )
       : null}
    </FormWrapper>
  );
};

OptionsTableRow.defaultProps = {
  defaultValue: [],
};

OptionsTableRow.propTypes = {
  option: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  deleteOptions: PropTypes.func.isRequired,
  editOptions: PropTypes.func.isRequired,
  formType: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  updateSchema: PropTypes.func.isRequired,
  setDefaultValues: PropTypes.func.isRequired,
};

SetOptionsForm.defaultProps = {
  defaultValue: [],
};

SetOptionsForm.propTypes = {
  addOptions: PropTypes.func.isRequired,
  editOptions: PropTypes.func.isRequired,
  deleteOptions: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  formType: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  updateSchema: PropTypes.func.isRequired,
  setSchema: PropTypes.func.isRequired,
};

export default SetOptionsForm;
